var _path, _path2, _path3, _path4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 641,
    viewBox: "0 0 644 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.904 353.94L529.354 279.261C543.593 274.326 547.819 256.23 537.239 245.499L399.516 105.809C388.936 95.0776 370.782 99.0462 365.645 113.213L287.918 327.583C282.036 343.804 297.601 359.591 313.904 353.94Z",
    fill: "#F45B69",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.847 310.904L363.526 526.354C368.462 540.593 386.557 544.819 397.288 534.239L536.979 396.516C547.71 385.936 543.741 367.782 529.574 362.645L315.204 284.918C298.984 279.036 283.196 294.601 288.847 310.904Z",
    fill: "#F45B69",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.536 286.151L115.085 360.831C100.847 365.766 96.6208 383.861 107.201 394.593L244.924 534.283C255.504 545.014 273.657 541.046 278.794 526.878L356.522 312.509C362.403 296.288 346.838 280.501 330.536 286.151Z",
    fill: "#F45B69",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.478 329.536L279.799 114.085C274.863 99.8465 256.768 95.6208 246.037 106.201L106.346 243.924C95.6152 254.504 99.5839 272.657 113.751 277.794L328.121 355.522C344.341 361.403 360.129 345.838 354.478 329.536Z",
    fill: "#F45B69",
    stroke: "black",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.324,
    cy: 323.325,
    rx: 85.1299,
    ry: 85.0394,
    transform: "rotate(45.4064 322.324 323.325)",
    fill: "#F45B69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.d01e46a3239727d7c49d38bffb18e62f.svg";
export { ForwardRef as ReactComponent };